// Unid Action Types
const UNID_PREFIX = 'UNID_'

export const UNID = {
  // List operations
  LIST_REQUEST: `${UNID_PREFIX}LIST_REQUEST`,
  LIST_SUCCESS: `${UNID_PREFIX}LIST_SUCCESS`,
  LIST_FAILURE: `${UNID_PREFIX}LIST_FAILURE`,
  
  // Create operations
  CREATE_REQUEST: `${UNID_PREFIX}CREATE_REQUEST`,
  CREATE_SUCCESS: `${UNID_PREFIX}CREATE_SUCCESS`,
  CREATE_FAILURE: `${UNID_PREFIX}CREATE_FAILURE`,
  
  // Update operations
  UPDATE_REQUEST: `${UNID_PREFIX}UPDATE_REQUEST`,
  UPDATE_SUCCESS: `${UNID_PREFIX}UPDATE_SUCCESS`,
  UPDATE_FAILURE: `${UNID_PREFIX}UPDATE_FAILURE`,
  
  // Delete operations
  DELETE_REQUEST: `${UNID_PREFIX}DELETE_REQUEST`,
  DELETE_SUCCESS: `${UNID_PREFIX}DELETE_SUCCESS`,
  DELETE_FAILURE: `${UNID_PREFIX}DELETE_FAILURE`,
  
  // Detail operations
  GET_DATA: `${UNID_PREFIX}GET_DATA`,
  GET_SELECTED_DETAIL: `${UNID_PREFIX}GET_SELECTED_DETAIL`,
  RESET_SELECTED_DETAIL: `${UNID_PREFIX}RESET_SELECTED_DETAIL`,
  
  // Clear notifications
  CLEAR_NOTIFY: `${UNID_PREFIX}CLEAR_NOTIFY`
}